import { render, staticRenderFns } from "./AgencyFormPlatform.vue?vue&type=template&id=504a2342&scoped=true&"
import script from "./AgencyFormPlatform.vue?vue&type=script&lang=js&"
export * from "./AgencyFormPlatform.vue?vue&type=script&lang=js&"
import style0 from "./AgencyFormPlatform.vue?vue&type=style&index=0&id=504a2342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504a2342",
  null
  
)

component.options.__file = "AgencyFormPlatform.vue"
export default component.exports